// extracted by mini-css-extract-plugin
module.exports = {"icon":"index_icon_1_rhn","title":"index_title_26Rpx","search-results":"index_search-results_3doKE"};